import { LitElement, html, css, nothing } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { MEDIA_BASE } from '../Settings';
import { Button, RenderButton } from '../Shared/Button';
import { BlockSettingsElementModel, IApiContentModel, SingleStyleElementModel, SingleStyleSettingsElementModel } from '../api/ContentDeliveryApi.schemas';
import { UmbracoPage } from '../ContentLoader';
import { translate } from '../Shared/Translations';

@customElement('lindberg-single-style')
export class SingleStyle extends LitElement {
    static styles = css`
        :host {
            display: flex;
            box-sizing: border-box;
            flex-direction: column;   
            align-items: center;
            font-size: var(--font-size-body-lg);
            color: var(--color-navigation-primary);
            padding: var(--layout-spacing-lg);
            gap: var(--layout-spacing-sm);
            
        }
        
        /* Not display: contents, elements without a box can't receive keyboard focus */
        a {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: inherit;
            width: 100%;
            color: inherit;
            text-decoration: none;

            &:focus-visible {
                outline: 2px solid var(--color-secondary-blue);
                outline-offset: 2px;
            }
        }

        img{
            display: inline-block;
            width: 100%;
            aspect-ratio: 16 / 9;
        }

        div {
            display: contents;
        }

        :host(.compact){
            @media (width >= 600px) {
                padding: 0 var(--layout-spacing-lg);
            }
            div {
                display: flex;
                gap: var(--layout-spacing-sm);
            }
        }
        p {
            margin: 0;
        }


        .dot {
            width: var(--product-tile-colour-diameter);
            align-self: center;
        }
    `

    @query("img")
    image!: HTMLImageElement;

    private _data!: { content: SingleStyleElementModel; settings?: SingleStyleSettingsElementModel; };
    public get data(): { content: SingleStyleElementModel; settings?: SingleStyleSettingsElementModel; } {
        return this._data;
    }
    public set data(value: { content: SingleStyleElementModel; settings?: SingleStyleSettingsElementModel; }) {
        this._data = value;
        if( this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
        if(this.data.settings?.properties.variant) this.classList.add(this.data.settings.properties.variant)
    }
    root!: UmbracoPage;

    @query('lindberg-button')
    cta?: Button
    
    firstUpdated() {
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)        
    }

	override onmouseenter = (e: MouseEvent) => {
		this.cta?.classList.add('hover');
	}

	override onmouseleave = (e: MouseEvent) => {
		this.cta?.classList.remove('hover');
	}

    render() {
        const dot = this.data.content.properties.dot?.at(0)
        const params = new URLSearchParams(this.data.content.properties.configuration!)
        const model = params.get("MODEL")?.split(" ").at(0) ?? ""
        const productPage = (this.root?.properties?.productPage as IApiContentModel)?.route?.path?.replace("*", model) ?? ""
        const content = html`
            <img src="https://realtime.lindberg.com/image/${this.data.content.properties.cameraAngle}/Large?${this.data.content.properties.configuration}" alt="LINDBERG ${this.data.content.properties.model}" />
            <div>
                ${dot ? html`<img class="dot" alt="" aria-hidden="true" focusable="false" src="${MEDIA_BASE}${dot.url}?format=webp" style="aspect-ratio: ${dot.width} / ${dot.height}" />` : nothing}
                <p>${this.data.content.properties.model}</p>
            </div>`

        return html`
        ${productPage ? html`
            <a href="${productPage}?${this.data.content.properties.configuration}"> 
                ${content}            
            <lindberg-button text large type="inline">${translate('customise')}
                <lindberg-icon><svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M181.65 122.35C184.75 125.45 184.75 130.55 181.65 133.65L101.65 213.65C98.5499 216.75 93.4499 216.75 90.3499 213.65C87.2499 210.55 87.2499 205.45 90.3499 202.35L164.7 128L90.3499 53.65C87.2499 50.55 87.2499 45.45 90.3499 42.35C93.4499 39.25 98.5499 39.25 101.65 42.35L181.65 122.35Z" fill="black"/>
                </svg></lindberg-icon>
            </lindberg-button>
        </a>` : content}`
    }
}    

declare global {
  interface HTMLElementTagNameMap {
    'lindberg-single-style': SingleStyle;
  }
}
